export default "__VITE_ASSET__bZ7C3hy4__"